__webpack_require__.p = "/Trybe-Project-12-Solar-System/";